import _ from 'lodash';

import {
  PRAECE_ADMIN_ROLES,
  PRAECE_LEAD_ROLES,
  PRAECE_OPERATIONS_ROLES,
  PRAECE_ROLES
} from 'constants';


// Always place more-specific routes beneath less specific routes
// i.e. '/users/add' after '/users'.
//
// If you do not specify a policy for a more-specific route, it will take the policy for its parent
// (i.e. if /users has been specified, but /users/add has not, /users/add will use the policy for /users)
const policies = {
  '/': PRAECE_ROLES,
  '/accounting/billing': PRAECE_OPERATIONS_ROLES,
  '/accounting/invoices': PRAECE_OPERATIONS_ROLES,
  '/admin/agreements': PRAECE_LEAD_ROLES,
  '/admin/settings': PRAECE_ADMIN_ROLES
};


export function getForbidden(currentRoute, currentUser) {
  const routePolicy = _.findLast(policies, (policy, key) => _.startsWith(currentRoute, key));
  return !_.find(routePolicy, (role) => role === currentUser.role);
}



// WEBPACK FOOTER //
// ./app/app-policies.js